import { SignIn } from 'containers/index';
import React, { FC } from 'react';

const SignInPage: FC = () => {
  return <SignIn />;
};

export default SignInPage;
